import classNames from 'classnames'

import Icon, { EDHRECIconsType } from '@/components/Icon/Icon'

import styles from './BracketBlock.module.scss'

type Props = {
  description: string
  label: string
  state: 'success' | 'warning' | 'error'
  subtext?: string
  title: string
}

const ICON_MAP: Record<Props['state'], EDHRECIconsType> = {
  error: 'xMark',
  success: 'check',
  warning: 'exclamation',
}

const BracketInfo = ({ description, label, state, subtext, title }: Props) => {
  return (
    <div className={classNames(styles.bracketContainer, styles[state])}>
      <div className={styles.leftBorder} />
      <div className={styles.rightBorder} />
      <div className={styles.numberContainer}>{label}</div>
      <h2 className={styles.title}>{title}</h2>
      {subtext && <div className={styles.subtext}>{subtext}</div>}
      <div className={styles.spacer} />
      <div className='d-grid gap-3 text-center'>{description}</div>
      <div className='flex-grow-1 d-flex align-items-end m-3 fa-2x'>
        <Icon icon={ICON_MAP[state]} />
      </div>
    </div>
  )
}

export default BracketInfo
